(() => {
    "use strict";

    let lastCartState = "";

    const paymentImageUrl = window.KYRA_PAYMENT_METHODS_IMAGE || "";

    function formatMoney(cents, withCurrency = false, currency = "MXN") {
        const value = Number(cents || 0) / 100;
        const amount = new Intl.NumberFormat("es-MX", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
        return `$${amount}${withCurrency ? ` ${currency}` : ""}`;
    }

    function fixProgressStructure() {
        const carousel = document.querySelector("#corner-cowi-cart-progress-bar-carousel");
        if (!carousel || carousel.dataset.kyraAdjusted === "true") return;

        const slides = Array.from(carousel.querySelectorAll(":scope > .corner-cowi-progress-bar-container"));
        if (slides.length < 2) return;

        const firstSlide = slides[0];
        const secondSlide = slides[1];
        const firstSegments = firstSlide.querySelector(".corner-cowi-progress-bar-segment-4-tier");
        const secondSegments = secondSlide.querySelector(".corner-cowi-progress-bar-segment-2-tier");
        const firstLabels = firstSlide.querySelector(".corner-cowi-progress-milestones-4-tier");
        const secondLabels = secondSlide.querySelector(".corner-cowi-progress-milestones-2-tier");
        if (!firstSegments || !secondSegments || !firstLabels || !secondLabels) return;

        /* Mueve el cuarto beneficio (-10% OFF) desde la primera pagina hasta el inicio de la segunda. */
        const fourthSegment = firstSegments.querySelector(".corner-cowi-progress-bar-segment-4");
        const fourthLabel = firstLabels.querySelector("#corner-cowi-goal-milestone-label-1-4");

        if (fourthSegment) {
            const secondFirstSegment = secondSegments.querySelector(".corner-cowi-progress-bar-segment");
            secondSegments.insertBefore(fourthSegment, secondFirstSegment);
        }
        if (fourthLabel) {
            const secondFirstLabel = secondLabels.querySelector(".corner-cowi-goal-milestone-label");
            secondLabels.insertBefore(fourthLabel, secondFirstLabel);
        }

        firstSegments.classList.remove("corner-cowi-progress-bar-segment-4-tier");
        secondSegments.classList.remove("corner-cowi-progress-bar-segment-2-tier");
        firstSegments.classList.add("kyra-progress-segments");
        secondSegments.classList.add("kyra-progress-segments");

        firstLabels.classList.remove("corner-cowi-progress-milestones-4-tier");
        secondLabels.classList.remove("corner-cowi-progress-milestones-2-tier");
        firstLabels.classList.add("kyra-progress-labels");
        secondLabels.classList.add("kyra-progress-labels");

        carousel.dataset.kyraAdjusted = "true";

        /* Corner estaba mostrando la segunda pagina. La regresamos a la primera. */
        requestAnimationFrame(() => {
            carousel.scrollLeft = 0;
            if (typeof carousel.scrollTo === "function") {
                carousel.scrollTo({ left: 0, behavior: "auto" });
            }
            carousel.dispatchEvent(new Event("scroll", { bubbles: true }));
        });
    }

    function getCartState() {
        const lines = Array.from(
            document.querySelectorAll('[id^="corner-cowi-cart-item-"][data-corner-variant-id]')
        ).map((line) => [line.dataset.cornerVariantId, line.dataset.quantity].join(":"));

        const discounts =
            document.querySelector("#corner-cowi-cart-discount-tags-wrapper")?.textContent || "";

        return `${lines.join("|")}:${discounts.trim()}`;
    }

    /* Precio de lista (precio tachado) por variante, para mostrar cuanto ahorra la clienta con las ofertas. */
    const productCache = {};
    function getProduct(handle) {
        if (!productCache[handle]) {
            productCache[handle] = fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } })
                .then((r) => (r.ok ? r.json() : null))
                .catch(() => null);
        }
        return productCache[handle];
    }

    async function listPriceTotal(cart) {
        let list = 0;
        for (const item of cart.items || []) {
            let unitList = item.original_price || item.price || 0;
            const p = await getProduct(item.handle);
            const v = p && p.variants && p.variants.find((x) => x.id === item.variant_id);
            if (v && v.compare_at_price && v.compare_at_price > unitList) {
                unitList = v.compare_at_price;
            }
            list += unitList * item.quantity;
        }
        return list;
    }

    async function renderSummary() {
        const detailsSection = document.querySelector("#corner-cowi-cart-summary-card-details-section");
        const discountSection = document.querySelector("#corner-cowi-cart-apply-discount-section");
        if (!detailsSection) return;

        /* Buscar nuestro contenedor. Si Corner no lo renderiza, lo creamos nosotros. */
        let wrapper = document.querySelector("#corner-cowi-cart-summary-items-wrapper");
        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.id = "corner-cowi-cart-summary-items-wrapper";
            if (discountSection) {
                detailsSection.insertBefore(wrapper, discountSection);
            } else {
                detailsSection.prepend(wrapper);
            }
        }

        try {
            const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
            if (!response.ok) {
                throw new Error(`No se pudo consultar el carrito: ${response.status}`);
            }
            const cart = await response.json();
            const currency = cart.currency || "MXN";

            const sellSubtotal =
                cart.original_total_price ?? cart.items_subtotal_price ?? cart.total_price ?? 0;
            const discount = cart.total_discount ?? 0;
            const total = cart.total_price ?? 0;

            const list = await listPriceTotal(cart);
            const sale = Math.max(0, list - sellSubtotal); /* ahorro por precio de oferta (tachado) */
            const subtotal = Math.max(list, sellSubtotal);
            const saved = sale + discount; /* precio de oferta + descuentos, mostrados como un solo ahorro */

            let rows = `
                <div class="kyra-cart-summary__row">
                    <span>Subtotal</span>
                    <span>${formatMoney(subtotal)}</span>
                </div>`;
            if (saved > 0) {
                rows += `
                <div class="kyra-cart-summary__row kyra-cart-summary__discount kyra-cart-summary__sale">
                    <span>Tu ahorro</span>
                    <span>-${formatMoney(saved)}</span>
                </div>`;
            }
            rows += `
                <div class="kyra-cart-summary__row kyra-cart-summary__row--total">
                    <span>Total</span>
                    <span>${formatMoney(total, true, currency)}</span>
                </div>`;

            wrapper.innerHTML = `<div class="kyra-cart-summary">${rows}</div>`;
        } catch (error) {
            console.error("[Kyra cart] Error actualizando resumen:", error);
        }
    }

    function mountPaymentMethods() {
        const checkoutWrapper = document.querySelector("#corner-cowi-cart-cta-wrapper");
        const checkoutButton = document.querySelector("#corner-cowi-cart-summary-card-cta-button");
        if (!checkoutWrapper || !checkoutButton || !paymentImageUrl) return;
        if (checkoutWrapper.querySelector("#kyra-corner-payment-methods")) return;

        const paymentMethods = document.createElement("div");
        paymentMethods.id = "kyra-corner-payment-methods";
        paymentMethods.setAttribute("aria-label", "Métodos de pago aceptados");
        paymentMethods.innerHTML = `
      <img
        src="${paymentImageUrl}"
        alt="Apple Pay, American Express, Mastercard, Visa y OXXO"
        width="196"
        height="20"
      >
    `;
        checkoutButton.insertAdjacentElement("afterend", paymentMethods);
    }

    let summaryRefreshing = false;

    /* SINCRONIZACION REAL DEL CART DE CORNER */
    async function synchronizeCornerCart() {
        const drawer = document.querySelector("#corner-cowi-open-primary-card");
        const products = document.querySelector("#corner-cowi-cart-item-list-card");
        const summary = document.querySelector("#corner-cowi-cart-summary-card");

        /* Si Corner ya creo los elementos, aplicamos el layout directamente. */
        if (!drawer || !products || !summary) return;

        fixProgressStructure();
        mountPaymentMethods();

        const upsellEl = document.querySelector("#corner-cowi-cart-oneclick-campaign-wrapper-card");
        if (upsellEl) {
            upsellEl.style.setProperty("display", "block", "important");
            upsellEl.style.setProperty("visibility", "visible", "important");
            upsellEl.style.setProperty("opacity", "1", "important");
            upsellEl.style.setProperty("height", "auto", "important");
            upsellEl.style.setProperty("overflow", "visible", "important");
        }

        /* Actualizar resumen solo si cambio */
        const currentState = getCartState();
        const summaryExists = document.querySelector("#corner-cowi-cart-summary-items-wrapper");

        if ((currentState !== lastCartState || !summaryExists) && !summaryRefreshing) {
            summaryRefreshing = true;
            try {
                await renderSummary();
                lastCartState = getCartState();
            } catch (error) {
                console.error("[Kyra cart] Error sincronizando:", error);
            } finally {
                summaryRefreshing = false;
            }
            mountPaymentMethods();
        }
    }

    /* CORNER WATCHER: si Corner crea el carrito, nosotros lo tomamos. */
    window.setInterval(() => {
        const drawer = document.querySelector("#corner-cowi-open-primary-card");
        const products = document.querySelector("#corner-cowi-cart-item-list-card");
        const summary = document.querySelector("#corner-cowi-cart-summary-card");
        if (drawer && products && summary) {
            synchronizeCornerCart();
        }
    }, 1000);

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            synchronizeCornerCart();
        });
    } else {
        synchronizeCornerCart();
    }
})();
